import { render, staticRenderFns } from "./BrowseQuickSearch.vue?vue&type=template&id=132b83d0"
import script from "./BrowseQuickSearch.vue?vue&type=script&lang=ts"
export * from "./BrowseQuickSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports